import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CustomerspagesService } from '../customerspages.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-customers-customers',
  templateUrl: './customers-customers.component.html',
  styleUrls: ['./customers-customers.component.scss'],
  imports: [SlickCarouselModule, ToHtmlPipe, CommonModule],
})
export class CustomersCustomersComponent implements OnInit, OnDestroy {
  constructor(private customersPagesService: CustomerspagesService) {
    this.subscriptions = [];
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  logosData: any;
  header: string = '';
  stats:any;

  ngOnInit(): void {
    this.customersPagesService.customersData$.subscribe(data => {
      if (data != null) {
        this.header = data?.customerStoriesClientsAndStats?.fields?.title || '';
        this.logosData =
          data?.customerStoriesClientsAndStats?.fields?.components || [];
        this.stats = data?.customerStoriesClientsAndStats?.fields?.components2;
      }
    });
  }

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    nav: true,
    arrows: true,
    rows: 2,
    loop: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  };
}
